import "@/App.css";
import { ReactLenis } from "lenis/react";
import Landing from "@/components/midlows/Landing";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true, wheelMultiplier: 1 }}>
      <Landing />
    </ReactLenis>
  );
}

export default App;
